import React from 'react';
import PropTypes from 'prop-types';
import TableBody from './TableBody';
import { Paginator } from '@forwardfinancing/component-library';
import LoadMoreTrigger from './LoadMoreTrigger';

function Table(props) {
  const usePaginator = (props.totalPages > 1) &&
    !props.searchError &&
    props.useTablePaginator;

  const useLoadMoreTrigger = !props.searchError &&
    props.loadMoreVisible &&
    props.useLoadMore;

  return (
    <div className="table page-font-scale">
      <div className="table__wrapper">
        <TableBody
          headers={props.headers}
          values={props.values}
          tableData={props.tableData}
          sortQuery={props.sortQuery}
          dataLabels={props.dataLabels}
          searchError={props.searchError}
          renderActionCell={props.renderActionCell}
          useSortArrows={props.useSortArrows}
          isAdmin={props.isAdmin}
          hasSpinner={props.hasSpinner}
          noDataMessage={props.noDataMessage}
        />
        {usePaginator && (
          <Paginator
            onClick={props.changePage}
            pageCount={props.totalPages}
            currentPage={props.currentPage}
          />
        )}
        {useLoadMoreTrigger && (
          <LoadMoreTrigger onClick={props.loadMore} />
        )}
      </div>
    </div>
  );
}

Table.propTypes = {
  tableData: PropTypes.array.isRequired,
  currentPage: PropTypes.number,
  totalPages: PropTypes.number,
  changePage: PropTypes.func,
  headers: PropTypes.array.isRequired,
  values: PropTypes.array.isRequired,
  dataLabels: PropTypes.array.isRequired,
  sortQuery: PropTypes.func,
  searchError: PropTypes.bool.isRequired,
  renderActionCell: PropTypes.func,
  useTablePaginator: PropTypes.bool,
  useLoadMore: PropTypes.bool,
  loadMore: PropTypes.func,
  loadMoreVisible: PropTypes.bool,
  useSortArrows: PropTypes.bool,
  isAdmin: PropTypes.bool,
  hasSpinner: PropTypes.bool,
  noDataMessage: PropTypes.string,
};

Table.defaultProps = {
  useTablePaginator: true,
  useSortArrows: true,
  useLoadMore: false,
  loadMoreVisible: false,
  hasSpinner: false
};


export default Table;
